import _sfc_main from "./component-library102.mjs";
import "./component-library103.mjs";
import normalizeComponent from "./component-library95.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _vm.variants ? _c("span", { staticClass: "variant-selector-color", attrs: { "role": "radiogroup", "aria-label": "Farbe auswählen" } }, _vm._l(_vm.variants, function(variant, index) {
    return _c(_setup.LinkButton, { key: index + variant.name, attrs: { "title": `Farbe: ${variant.name}`, "area-label": `Farbe: ${variant.name}`, "tag": _vm.noLink ? "span" : "button", "role": "radio", "aria-checked": index === _vm.value ? "true" : "false", "tabindex": _vm.isAccessible ? void 0 : -1, "open-on-hover": "", "icon-only": "", "outline-primary": index === _vm.value, "outline": index !== _vm.value, "checked": index === _vm.value, "open-on-click": "" }, on: { "click": function($event) {
      _vm.$emit("input", index);
      _vm.$emit("select-variant", { variant });
    } } }, [_c("span", { staticClass: "variant-selector-color__inner", style: _setup.style(variant.color) })]);
  }), 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "651ed9c5",
  null,
  null
);
const ColorSelector = __component__.exports;
export {
  ColorSelector as default
};
